import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="py-24 bg-beige relative overflow-hidden" data-id="element-96">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-97">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative h-[400px] lg:h-[600px] rounded-3xl overflow-hidden shadow-lg" data-id="element-99">
            <img src="https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?q=80&w=1000&auto=format&fit=crop" alt="Ingredientes naturales para el cuidado de la piel" className="absolute inset-0 w-full h-full object-cover" data-id="element-100" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-101">
            <h2 className="text-4xl lg:text-5xl font-medium text-brown mb-6" data-id="element-102">
              La belleza de lo simple
            </h2>
            <p className="text-xl text-brown/80 font-light leading-relaxed" data-id="element-103">
              El{' '}
              <strong className="font-medium" data-id="element-104">Método Piel Clara Natural</strong>{' '}
              es una guía práctica que te ayuda a organizar tu rutina de cuidado
              facial de forma simple, natural y accesible.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}